module.exports = __webpack_public_path__ + "img/y.3961da6d.jpg";